import { getUser, supabase } from ".";

export const getAppointments = async () => {
  try {
    const user = await getUser();

    if (!user) {
      throw new Error("User not found");
    }

    const { data, error: appointmentsError } = await supabase
      .from("appointments")
      .select("*")
      .or(`installer_id.eq.${user.id}`);

    if (appointmentsError) {
      throw new Error(
        "Error getting appointments: " + appointmentsError.message,
      );
    }

    return data;
  } catch (error) {
    if (error instanceof Error) {
      console.error(error.message);
    } else {
      console.error("An unknown error occurred:", error);
    }
    return null;
  }
};

export const getAppointmentById = async (appointmentId: string) => {
  try {
    const { data, error: appointmentError } = await supabase
      .from("appointments")
      .select(
        "*, users (first_name, last_name), projects( * , users(first_name, last_name, phone_number)), images(*)",
      )
      .eq("appointment_id", appointmentId)
      .single();
    if (appointmentError) {
      throw new Error("Error getting appointment: " + appointmentError.message);
    }

    if (!data) {
      throw new Error(`Appointment with id ${appointmentId} not found`);
    }

    return data;
  } catch (error) {
    if (error instanceof Error) {
      console.error(error.message);
    } else {
      console.error("An unknown error occurred:", error);
    }
    return null;
  }
};

export const updateStatusInSupabase = async (
  appointment_id: string,
  newStatus: string,
) => {
  const { error } = await supabase
    .from("appointments")
    .update({ status: newStatus })
    .eq("appointment_id", appointment_id)
    .select("status");

  if (error) {
    console.error("Error updating status:", error.message);
  }
};

export const getAppointmentsByClientId = async () => {
  try {
    const user = await getUser();

    if (!user) {
      throw new Error("User not found");
    }

    const { data, error } = await supabase
      .from("appointments")
      .select("*, projects!inner(client_id)")
      .eq("projects.client_id", user.id);

    if (error) throw error;

    return data;
  } catch (error) {
    console.error("Error fetching appointments:", error);
    return null;
  }
};
